import produce, { setAutoFreeze } from "immer"
import { merge, mergeWith } from "lodash-es"
import type { InputArg } from "./InputArg"

// Mock data must stay mutable: Storybook's arg traversal (traverseArgs /
// nameSpiesAndWrapActionsInSpies) writes into args in place, which throws on
// immer's frozen output. Mocks are meant to be manipulated, so opt out.
setAutoFreeze(false)

export const mergeMock = <T>(data: T, input: InputArg<T>) => {
  if (input === undefined) return merge({}, data)
  if (typeof input === "function") return produce(data, input)
  return mergeWith({}, data, input, (_, newValue) => {
    // Don't merge arrays. Replace the entire array with the new value
    if (Array.isArray(newValue)) return newValue
  })
}
